const IST_TIME_ZONE = 'Asia/Kolkata';

export function formatDateTimeIST(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat('en-IN', {
    timeZone: IST_TIME_ZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
}

export function formatDateIST(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat('en-IN', {
    timeZone: IST_TIME_ZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
}

export function toIstDateKey(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('en-CA', {
    timeZone: IST_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

export function sortByCreationDesc(items = []) {
  return [...items].sort((a, b) => {
    const aTime = a?.creationDate ? new Date(a.creationDate).getTime() : 0;
    const bTime = b?.creationDate ? new Date(b.creationDate).getTime() : 0;
    return bTime - aTime;
  });
}

export function filterDeals(items = [], filters = {}) {
  const productCode = (filters.productCode || '').trim().toLowerCase();
  const productName = (filters.productName || '').trim().toLowerCase();
  const brandName = (filters.brandName || '').trim().toLowerCase();
  const creationDate = (filters.creationDate || '').trim();

  return sortByCreationDesc(
    items.filter((item) => {
      if (productCode && !(item.productCode || '').toLowerCase().includes(productCode)) {
        return false;
      }
      if (productName && !(item.productName || '').toLowerCase().includes(productName)) {
        return false;
      }
      if (brandName && !(item.brandName || '').toLowerCase().includes(brandName)) {
        return false;
      }
      if (creationDate && toIstDateKey(item.creationDate) !== creationDate) {
        return false;
      }
      return true;
    })
  );
}

export function countActiveDealFilters(filters = {}) {
  return ['productCode', 'productName', 'brandName', 'creationDate']
    .filter((key) => String(filters[key] || '').trim())
    .length;
}
